import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2v16h16l4 4V2zm-4 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
}), 'InsertCommentSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/InsertCommentSharp.js
// module id = 4267
// module chunks = 2